import { VIAL_IMG } from "@/lib/api";
import { ProductLabel } from "@/components/ProductLabel";

// Displays the peptide vial with the product label printed/wrapped onto the body.
// Cylinder shading (dark edges, bright center) makes the flat label read as if it is
// curved around the round vial rather than floating on top of it.
export const ProductVial = ({ product, className = "", ...rest }) => (
  <div className={"relative " + className} {...rest}>
    <img
      src={product.image || VIAL_IMG}
      alt={product.name}
      className="w-full h-full object-contain select-none"
      draggable="false"
    />

    {/* Label band positioned on the vial body */}
    <div
      className="absolute left-1/2 top-[52%] -translate-x-1/2 -translate-y-1/2 w-[53%]"
      style={{ perspective: "1000px" }}
    >
      <div className="relative" style={{ transform: "rotateX(3deg)" }}>
        <ProductLabel
          product={product}
          className="w-full block"
          style={{ borderRadius: "9px", boxShadow: "0 2px 5px rgba(11,26,41,0.18)" }}
        />

        {/* cylinder curvature: darken left/right edges (multiply) */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            borderRadius: "9px",
            background:
              "linear-gradient(90deg, rgba(6,17,28,0.42) 0%, rgba(6,17,28,0.12) 9%, rgba(6,17,28,0) 26%, rgba(6,17,28,0) 74%, rgba(6,17,28,0.12) 91%, rgba(6,17,28,0.42) 100%)",
            mixBlendMode: "multiply",
          }}
        />
        {/* soft center sheen (screen) for the glossy curve highlight */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            borderRadius: "9px",
            background:
              "linear-gradient(90deg, rgba(255,255,255,0) 30%, rgba(255,255,255,0.35) 50%, rgba(255,255,255,0) 70%)",
            mixBlendMode: "screen",
          }}
        />
        {/* subtle top/bottom edge shading so it bends onto the vial */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            borderRadius: "9px",
            background:
              "linear-gradient(180deg, rgba(6,17,28,0.16) 0%, rgba(6,17,28,0) 14%, rgba(6,17,28,0) 86%, rgba(6,17,28,0.16) 100%)",
            mixBlendMode: "multiply",
          }}
        />
      </div>
    </div>
  </div>
);
